import React from "react";

/**
 * TeamToggle - Toggle between two teams
 * Used in Add Result modal to select which team scored/received card
 */
const TeamToggle = ({ team1, team2, isTeam1Selected, onToggle }) => {
  return (
    <div className="relative w-full max-w-[520px] h-[45px] bg-[#021326] rounded-full flex items-center p-1 overflow-hidden">
      {/* Sliding Indicator */}
      <div
        className={`absolute h-[37px] bg-[#082441] rounded-full transition-all duration-300 ease-in-out ${
          isTeam1Selected ? "left-[calc(50%+2px)] right-1" : "left-1 right-[calc(50%+2px)]"
        }`}
      />

      {/* Team Options */}
      <button
        type="button"
        onClick={() => onToggle?.(false)}
        className="relative z-10 flex-1 flex items-center justify-center h-full"
      >
        <span className={`text-sm font-semibold transition-colors truncate px-2 ${!isTeam1Selected ? "text-[#FEFCEB]" : "text-[#7F8585]"}`}>
          {team1}
        </span>
      </button>
      <button
        type="button"
        onClick={() => onToggle?.(true)}
        className="relative z-10 flex-1 flex items-center justify-center h-full"
      >
        <span className={`text-sm font-semibold transition-colors truncate px-2 ${isTeam1Selected ? "text-[#FEFCEB]" : "text-[#7F8585]"}`}>
          {team2}
        </span>
      </button>
    </div>
  );
};

export default TeamToggle;
